import React from 'react';

/**
 * Reusable Stats Cards Component
 * Displays statistics in a responsive grid
 */
const StatsCards = ({ stats }) => {
  if (!stats || stats.length === 0) return null;

  // Tailwind only generates classes it can see at build time, so the
  // column count must map to static class strings.
  const mdCols = {
    1: 'md:grid-cols-1',
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-4',
  }[Math.min(stats.length, 4)];

  return (
    <div className={`grid grid-cols-1 min-[420px]:grid-cols-2 ${mdCols} gap-2 md:gap-3`}>
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`px-4 py-2 ${stat.gradient || 'bg-gradient-to-r from-purple-500 to-purple-600'} text-white rounded-xl text-sm font-medium shadow-sm truncate`}
          title={`${stat.label}: ${stat.value}`}
        >
          {stat.label}: {stat.value}
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
